import { render } from "./UserProfile.vue?vue&type=template&id=662628cc&scoped=true"
import script from "./UserProfile.vue?vue&type=script&lang=js"
export * from "./UserProfile.vue?vue&type=script&lang=js"

import "./UserProfile.vue?vue&type=style&index=0&id=662628cc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-662628cc"]])

export default __exports__